import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import EligibilitySection from './components/EligibilitySection';
import ProcessSection from './components/ProcessSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import FloatingGuide from './components/FloatingGuide';

export default function HomePage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <EligibilitySection />
        <ProcessSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />

      {/* Fixed Bottom CTA (Mobile) */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 px-4 py-3 flex gap-3 md:hidden">
        <a
          href="tel:01066065909"
          className="flex-1 flex items-center justify-center gap-2 bg-[#03C75A] text-white font-bold py-3 rounded-lg text-sm cursor-pointer"
        >
          <i className="ri-phone-fill"></i>
          전화 상담
        </a>
        <a
          href="#contact"
          onClick={(e) => {
            e.preventDefault();
            const el = document.querySelector('#contact');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="flex-1 flex items-center justify-center gap-2 border-2 border-[#03C75A] text-[#03C75A] font-bold py-3 rounded-lg text-sm cursor-pointer"
        >
          <i className="ri-chat-3-line"></i>
          온라인 상담
        </a>
      </div>

      {/* Floating Guide */}
      <FloatingGuide />
    </div>
  );
}
